/**
 * Copyright (c) 2019 mol* contributors, licensed under MIT, See LICENSE file for more info.
 *
 * @author David Sehnal <david.sehnal@gmail.com>
 */
import * as Structure from './actions/structure';
import * as Volume from './actions/volume';
import * as DataFormat from './actions/file';
export var StateActions = {
    Structure: Structure,
    Volume: Volume,
    DataFormat: DataFormat
};
